import React from "react";
import type { FC } from "react";

import cn from "classnames";

import { slotFactory } from "../../utils/slotFactory";
import {
    UNIBOX_MAIN_SLOT_BOTTOM_DISPLAY_NAME,
    UNIBOX_MAIN_SLOT_BOTTOM_LEFT_DISPLAY_NAME,
    UNIBOX_MAIN_SLOT_BOTTOM_LEFT_TEST_ID,
    UNIBOX_MAIN_SLOT_BOTTOM_RIGHT_DISPLAY_NAME,
    UNIBOX_MAIN_SLOT_BOTTOM_RIGHT_TEST_ID,
    UNIBOX_MAIN_SLOT_BOTTOM_TEST_ID,
    UNIBOX_MAIN_SLOT_DISPLAY_NAME,
    UNIBOX_MAIN_SLOT_LEFT_DISPLAY_NAME,
    UNIBOX_MAIN_SLOT_LEFT_TEST_ID,
    UNIBOX_MAIN_SLOT_MIDDLE_DISPLAY_NAME,
    UNIBOX_MAIN_SLOT_MIDDLE_TEST_ID,
    UNIBOX_MAIN_SLOT_RIGHT_DISPLAY_NAME,
    UNIBOX_MAIN_SLOT_RIGHT_TEST_ID,
    UNIBOX_MAIN_SLOT_TEST_ID,
    UNIBOX_MAIN_SLOT_TOP_DISPLAY_NAME,
    UNIBOX_MAIN_SLOT_TOP_LEFT_DISPLAY_NAME,
    UNIBOX_MAIN_SLOT_TOP_LEFT_TEST_ID,
    UNIBOX_MAIN_SLOT_TOP_RIGHT_DISPLAY_NAME,
    UNIBOX_MAIN_SLOT_TOP_RIGHT_TEST_ID,
    UNIBOX_MAIN_SLOT_TOP_TEST_ID,
} from "../../vars";

import type { UniBoxMainSlotProps } from "./types";

import classes from "./UniBoxMainSlot.styl";

export const UniBoxMainSlot: FC<UniBoxMainSlotProps> = ({
    "data-tsid": tsid = UNIBOX_MAIN_SLOT_TEST_ID,
    children,
    alignmentY = "center",
    alignmentX = "center",
    customVarsStyles,
}) => {
    const slotStyles = {
        "--uni-box-slot-alignment-y": alignmentY,
        "--uni-box-slot-alignment-x": alignmentX,
    };

    const slotClassnames = cn(classes["uni-box-main-slot"], customVarsStyles);

    return (
        <div className={slotClassnames} style={slotStyles} data-tsid={tsid}>
            {children}
        </div>
    );
};

UniBoxMainSlot.displayName = UNIBOX_MAIN_SLOT_DISPLAY_NAME;

export const UniBoxMainSlotBottom = slotFactory({
    slotType: "SlotBottom",
    displayName: UNIBOX_MAIN_SLOT_BOTTOM_DISPLAY_NAME,
    defaultTsid: UNIBOX_MAIN_SLOT_BOTTOM_TEST_ID,
});

export const UniBoxMainSlotBottomLeft = slotFactory({
    slotType: "SlotBottomLeft",
    displayName: UNIBOX_MAIN_SLOT_BOTTOM_LEFT_DISPLAY_NAME,
    defaultTsid: UNIBOX_MAIN_SLOT_BOTTOM_LEFT_TEST_ID,
});

export const UniBoxMainSlotBottomRight = slotFactory({
    slotType: "SlotBottomRight",
    displayName: UNIBOX_MAIN_SLOT_BOTTOM_RIGHT_DISPLAY_NAME,
    defaultTsid: UNIBOX_MAIN_SLOT_BOTTOM_RIGHT_TEST_ID,
});

export const UniBoxMainSlotLeft = slotFactory({
    slotType: "SlotLeft",
    displayName: UNIBOX_MAIN_SLOT_LEFT_DISPLAY_NAME,
    defaultTsid: UNIBOX_MAIN_SLOT_LEFT_TEST_ID,
});

export const UniBoxMainSlotMiddle = slotFactory({
    slotType: "SlotMiddle",
    displayName: UNIBOX_MAIN_SLOT_MIDDLE_DISPLAY_NAME,
    defaultTsid: UNIBOX_MAIN_SLOT_MIDDLE_TEST_ID,
});

export const UniBoxMainSlotRight = slotFactory({
    slotType: "SlotRight",
    displayName: UNIBOX_MAIN_SLOT_RIGHT_DISPLAY_NAME,
    defaultTsid: UNIBOX_MAIN_SLOT_RIGHT_TEST_ID,
});

export const UniBoxMainSlotTop = slotFactory({
    slotType: "SlotTop",
    displayName: UNIBOX_MAIN_SLOT_TOP_DISPLAY_NAME,
    defaultTsid: UNIBOX_MAIN_SLOT_TOP_TEST_ID,
});

export const UniBoxMainSlotTopLeft = slotFactory({
    slotType: "SlotTopLeft",
    displayName: UNIBOX_MAIN_SLOT_TOP_LEFT_DISPLAY_NAME,
    defaultTsid: UNIBOX_MAIN_SLOT_TOP_LEFT_TEST_ID,
});

export const UniBoxMainSlotTopRight = slotFactory({
    slotType: "SlotTopRight",
    displayName: UNIBOX_MAIN_SLOT_TOP_RIGHT_DISPLAY_NAME,
    defaultTsid: UNIBOX_MAIN_SLOT_TOP_RIGHT_TEST_ID,
});
